import { Component, ElementRef } from '@angular/core';
import { Params } from '@angular/router';
import { BaseWidget } from '../BaseWidget/BaseWidget.component';
import { DisplayStateService } from '../../../services/DisplayStateService';
import { AppStateService } from '../../../services/AppStateService';
import { WebPlatformApiService } from '../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../services/ClientSettingsService';

@Component({
  selector: 'app-lot-forecaster',
  template: `<p>
  lot-forecaster works!
</p>
`,
  styles: [``]
})
export class LotForecasterComponent extends BaseWidget {
  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }

  onInitialize() {}

  onNewMessage(messageParams: Params) {}

  onContextChanged(currentContext: Params) {}

  onFiltersChanged(currentFilters: Params) {}

  onSortsChanged(currentSorts: Params) {}
}
